<template>
  <v-col class="pa-0">
    <v-card flat tile class="d-flex flex-column text-left">
      <v-btn
        color="primary"
        style="
          justify-content: space-between;
          color: rgba(0, 0, 0, 0.87) !important;
          text-transform: unset;
        "
        x-large
        @click="handleSelectOption('live')"
        text
      >
        <span class="d-flex">
          <v-icon>mdi-access-point</v-icon>
          <p class="menuText">Dados da live</p>
        </span>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'LivePlayerOptions',
  props: {
    handleSelectOption: {
      type: Function,
      required: true,
    },
  },
  mounted() {
    this.handleSelectOption('live')
  },
}
</script>
